import { populateAsync, populateNotifications } from '../utility/constants';

const asyncActions = [
  'DELETE_ORDER',
  'CREATE_PURCHASER_SCHEDULE_ORDER',
  'UPDATE_ORDER',

  'FETCH_FORM_PRODUCTS',

  'FETCH_PURCHASER_SCHEDULE',
  'FETCH_PURCHASERS',

  'CANCEL_SCHEDULE_ORDER',
  'CANCEL_ALL_SCHEDULE_ORDER',
  'RESTORE_SCHEDULE_ORDER',

  'SEND_PAGE_ANALYTICS',
  'FETCH_FLAGS',

  'ORDER_VALIDATION',
];

const populatedList = Object.freeze(
  asyncActions.reduce(
    (prev, next) => [
      ...prev,
      ...populateAsync(next),
      ...populateNotifications(next),
    ],
    []
  )
);

const populatedActions = {};

for (const action of populatedList) {
  populatedActions[action] = action;
}

export default populatedActions;
